import { useTranslation } from 'react-i18next'
import { useSettingsState } from '~/atoms/SettingsState'

import { SettingToggle } from './SettingItems'
import { DefaultSettingsWrapper, SubheadingSection } from './Shared'

interface FaxSettingsProps {
  pbxId: number | undefined
}
export const FaxSettings = ({ pbxId }: FaxSettingsProps) => {
  const { t } = useTranslation()
  const {
    settings: {
      fax: { includeCoverPage: isFaxCoverPageEnabled },
    },
    setFaxCoverPageEnabled,
  } = useSettingsState(pbxId)

  const handleFaxCoverPageToggle = () => {
    setFaxCoverPageEnabled(!isFaxCoverPageEnabled)
  }
  return (
    <DefaultSettingsWrapper>
      <SubheadingSection>
        <SettingToggle
          label={t('faxSettings.enableFaxCoverPage')}
          isChecked={isFaxCoverPageEnabled}
          onClick={handleFaxCoverPageToggle}
        />
      </SubheadingSection>
    </DefaultSettingsWrapper>
  )
}
